import React, { FC, ReactElement, useRef } from 'react';
import {useSelector} from 'react-redux';
import Swiper from 'react-id-swiper';
import { goNext, goPrev } from '../../../../../helpers/swiper';
import Icon from '../../../../Icon';
import {internalizationState, ParamsDto} from '../../../../../stores/reducers/sections';
import localeFieldResolver from '../../../../../helpers/locale-field-finder';
import cns from 'classnames';

interface Props {
  speakers: any[];
  allowTargetBeforeStart?: boolean;
  questionModalhandler?: CallableFunction;
  viewParams?: any;
}

const HorizontalView: FC<Props> = ({ speakers, viewParams }): ReactElement => {
  const { activeLangState } = useSelector(internalizationState);

  const photoRoundedParam = viewParams?.find((param: ParamsDto) => param.key === 'isSpeakerRounded') || '';
  const cardsQuantityParams = viewParams?.find((param: ParamsDto) => param.key === 'cardQuantity') || '';

  const swiperRef = useRef<any>();
  const swiperParams = {
    watchOverflow: true,
    slidesPerView: parseInt(cardsQuantityParams.value) || 3,
    // slidesPerView: 'auto' as 'auto',
    spaceBetween: 40,
    shouldSwiperUpdate: true,
    rebuildOnUpdate: true,
    breakpoints: {
      320: {
        slidesPerView: 1,
        spaceBetween: 20
      },
      480: {
        slidesPerView: 2,
        spaceBetween: 20
      },
      680: {
        slidesPerView: 3,
        spaceBetween: 30
      },
      860: {
        slidesPerView: parseInt(cardsQuantityParams.value) || 3,
        spaceBetween: 40
      }
    },
  };

  return (
    speakers && speakers.length ?
      <div className="speakers-horizontal">
        <Swiper
          ref={swiperRef}
          {...swiperParams}
        >
          {
            speakers.map((speaker: any, index: number) => (
              <div
                className="speakers-horizontal__speaker"
                key={index}
              >
                <div className={cns(
                    'speakers-horizontal__speaker__image',
                    photoRoundedParam.checked && 'rounded-photo'
                  )}
                >
                  <img src={speaker.photo} alt={ localeFieldResolver(speaker, 'fullnameRu', activeLangState) } />
                </div>
                <p className="speakers-horizontal__speaker__name">
                  { localeFieldResolver(speaker, 'fullnameRu', activeLangState) }
                </p>
                <p className="speakers-horizontal__speaker__description">
                  { localeFieldResolver(speaker, 'descriptionRu', activeLangState) }
                </p>
              </div>
            ))
          }
        </Swiper>
        <div className="slider-nav speakers-horizontal__nav hidden-mobile">
          <button className="slider-nav__prev speakers-horizontal__nav__btn" type="button" onClick={() => goPrev(swiperRef)}>
            <Icon name="md-arr-left" />
          </button>
          <button className="slider-nav__next speakers-horizontal__nav__btn" type="button" onClick={() => goNext(swiperRef)}>
            <Icon name="md-arr-right" />
          </button>
        </div>
        {/* <div className="speakers-horizontal__dots">
          {
            speakers.map((speaker: any, index: number) => (
              <div key={index} className="slider-dot"></div>
            ))
          }
        </div> */}
      </div>
    :
      <></>
  )
}

export default HorizontalView;
